<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_27942_14737)">
      <mask
        id="mask0_27942_14737"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <path d="M20 0H0V20H20V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_27942_14737)">
        <path
          d="M7.70833 1.05859C5.525 1.05859 3.75 2.83359 3.75 5.01693C3.75 7.20026 5.425 8.89191 7.60833 8.96691C7.675 8.95858 7.74167 8.95858 7.79167 8.96691H7.85C9.98333 8.89191 11.6583 7.15859 11.6667 5.01693C11.6667 2.83359 9.89167 1.05859 7.70833 1.05859Z"
          fill="#222222"
        />
        <path
          d="M16.8668 5.50868C17.0001 7.12534 15.8501 8.54199 14.2585 8.73366H14.2168C14.1668 8.73366 14.1168 8.73366 14.0751 8.75033C13.2668 8.79199 12.5251 8.53366 11.9668 8.05868C12.8251 7.29201 13.3168 6.14201 13.2168 4.89201C13.1585 4.21701 12.9251 3.60034 12.5751 3.07534C12.8918 2.91701 13.2585 2.81701 13.6335 2.78368C15.2668 2.64201 16.7251 3.85868 16.8668 5.50868Z"
          fill="#222222"
        />
        <path
          d="M18.5339 13.2173C18.4672 14.0256 17.9505 14.7256 17.0839 15.2006C16.2505 15.6589 15.2005 15.8756 14.1589 15.8506C14.7589 15.3089 15.1089 14.6339 15.1755 13.9173C15.2589 12.8839 14.7672 11.8923 13.7839 11.1006C13.2255 10.6589 12.5755 10.3089 11.8672 10.0506C13.7089 9.51726 16.0255 9.87559 17.4505 11.0256C18.2172 11.6423 18.6089 12.4173 18.5339 13.2173Z"
          fill="#222222"
        />
        <path
          d="M11.9418 11.183C9.61678 9.63301 5.82513 9.63301 3.48346 11.183C2.42513 11.8913 1.8418 12.8497 1.8418 13.8747C1.8418 14.1997 1.90846 14.508 2.0168 14.8163L2.23346 14.758C2.65846 14.633 2.9668 14.3247 3.08346 13.908L3.30013 13.1163L3.35013 12.9747C3.50846 12.558 3.90846 12.283 4.3668 12.283C4.83346 12.283 5.20846 12.5663 5.3668 12.983L5.62513 13.9163C5.73346 14.333 6.05846 14.6497 6.4668 14.7663L7.43346 15.0413C7.85013 15.2163 8.10013 15.608 8.10013 16.0663C8.10013 16.5518 7.76778 16.9634 7.30846 17.108L6.48346 17.333C6.32513 17.3747 6.18346 17.458 6.05846 17.5497C6.60013 17.6497 7.15013 17.7247 7.70846 17.7247C9.24178 17.7247 10.7751 17.333 11.9418 16.5497C12.9918 15.8413 13.5751 14.8913 13.5751 13.858C13.5668 12.833 12.9918 11.883 11.9418 11.183Z"
          fill="#222222"
        />
        <path
          d="M7.28398 16.0423C7.28398 16.1006 7.25065 16.2339 7.09232 16.2839L6.27565 16.5089C5.56732 16.7006 5.03398 17.2339 4.84232 17.9423L4.62565 18.7423C4.57565 18.9256 4.43398 18.9423 4.36732 18.9423C4.30065 18.9423 4.15898 18.9256 4.10898 18.7423L3.89232 17.9339C3.70065 17.2339 3.15898 16.7006 2.45898 16.5089L1.65065 16.2923C1.47565 16.2423 1.45898 16.0923 1.45898 16.0339C1.45898 15.9673 1.47565 15.8173 1.65065 15.7673L2.46732 15.5506C3.16732 15.3506 3.70065 14.8173 3.89232 14.1173L4.12565 13.2673C4.18398 13.1256 4.31732 13.1006 4.36732 13.1006C4.41732 13.1006 4.55898 13.1173 4.60898 13.2506L4.84232 14.1089C5.03398 14.8089 5.57565 15.3423 6.27565 15.5423L7.10898 15.7756C7.27565 15.8423 7.28398 15.9923 7.28398 16.0423Z"
          fill="#222222"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_27942_14737">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "TIActiveIcon",
};
</script>
